import React, { useContext, useRef } from "react";
import Cookies from "js-cookie";
import {
  Box,
  Heading,
  VStack,
  Flex,
  Link,
  Spacer,
  Button,
  ButtonGroup,
  useDisclosure,
  Divider,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useToast,
} from "@chakra-ui/react";
import { UserContext } from "../context/UserContext";
import { useHistory } from "react-router-dom";

const Nav = () => {
  const { user, loginStatus, setLoginStatus } = useContext(UserContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const history = useHistory();
  const toast = useToast();

  const logout = () => {
    Cookies.remove("username");
    Cookies.remove("password");
    Cookies.remove("token");
    setLoginStatus(false);
    toast({
      title: "Logout success",
      description: `See you, ${user.name}`,
      position: "top",
      status: "success",
      duration: 3000,
    });
    history.push("/");
    onClose();
  };

  return (
    <>
      <Flex
        as="nav"
        align="center"
        padding="1.5rem"
        justify="space-between"
        bg="gray.800"
        color="teal.200"
      >
        <Box>
          <Heading as="h1" size="md" letterSpacing={"-.1rem"}>
            <Link href="/" mt={{ base: 4, md: 0 }} mr={6} display="block">
              Movies & Games Database
            </Link>
          </Heading>
        </Box>
        <Spacer />
        {loginStatus ? (
          <Box>
            <Button
              mr={5}
              ml={5}
              colorScheme="teal"
              variant="outline"
              onClick={onOpen}
            >
              Account
            </Button>
          </Box>
        ) : (
          <Box>
            <ButtonGroup spacing="4">
              <Button
                colorScheme="teal"
                variant="link"
                onClick={() => history.push("/about")}
              >
                About
              </Button>
              <Button
                colorScheme="teal"
                variant="outline"
                onClick={() => history.push("/login")}
              >
                Login
              </Button>
              <Button
                colorScheme="teal"
                onClick={() => history.push("/register")}
              >
                Register
              </Button>
            </ButtonGroup>
          </Box>
        )}
      </Flex>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Hello, {user.name}</DrawerHeader>

          <DrawerBody>
            <VStack align="flex-start" spacing={2}>
              <Button variant="link">
                <Link href="/account">Account Dashboard</Link>
              </Button>
              <Divider />
              <Button variant="link">
                <Link href="/games">Games Page</Link>
              </Button>
              <Divider />
              <Button variant="link">
                <Link href="/movie/list">Movies List</Link>
              </Button>
              <Divider />
              <Button variant="link">
                <Link href="/game/list">Games List</Link>
              </Button>
              <Divider />
              <Button variant="link">
                <Link href="/about">About</Link>
              </Button>
              <Divider />
              <Button variant="link" onClick={logout}>
                Logout
              </Button>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Nav;
